import register from '../util/register'
import angular from 'angular'
import SubscriptionService from '../billing/SubscriptionService'
import ResultsGridDirective from './ResultsGridDirective'
import RecordFilterService from './RecordFilterService'
import '../../lib/ui-grid.js'
import '../../blocks/analytics/analytics.module'

var resultsGrid = angular.module(
  'app.resultsGrid',
  [
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.resizeColumns',
    'ui.grid.moveColumns',
    'ui.grid.pagination',
    'ui.grid.autoResize',
    'ui.grid.expandable',
    'blocks.analytics',
    'ngSanitize',
    'ngCsv',

  ])

register('app.resultsGrid')
  .directive('oseResultsGrid', ResultsGridDirective)
  .service('RecordFilterService', RecordFilterService)
  .service('SubscriptionService', SubscriptionService)

resultsGrid.run()
